/**
 * Lightweight wrapper around the xlsx library for client-side Excel export.
 * Each "sheet" is rendered as a worksheet in a single .xlsx file.
 *
 * Imports xlsx dynamically so the ~600KB library only loads when the user
 * clicks Export — keeps the main bundle lean.
 */

export type SheetSpec = {
  name: string;
  // Header row first, then one row per record. Cells can be string | number | null.
  rows: (string | number | null)[][];
};

export async function exportXlsx(filename: string, sheets: SheetSpec[]) {
  const XLSX = await import('xlsx');
  const wb = XLSX.utils.book_new();
  for (const s of sheets) {
    // Excel sheet names: max 31 chars, no [ ] : * ? / \
    const safeName = (s.name || 'Sheet').replace(/[\[\]:*?/\\]/g, '_').slice(0, 31);
    const ws = XLSX.utils.aoa_to_sheet(s.rows);
    XLSX.utils.book_append_sheet(wb, ws, safeName);
  }
  // Trigger browser download
  XLSX.writeFile(wb, filename);
}
